import { render, staticRenderFns } from "./SendboxItem2.vue?vue&type=template&id=4ad1fece&scoped=true&"
import script from "./SendboxItem2.vue?vue&type=script&lang=js&"
export * from "./SendboxItem2.vue?vue&type=script&lang=js&"
import style0 from "./SendboxItem2.vue?vue&type=style&index=0&id=4ad1fece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad1fece",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
